"use strict";
/**
 * @description Menus 菜单栏 入口文件
 * @author wangfupeng
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var menu_list_1 = __importDefault(require("./menu-list"));
// import { MenuActive } from './menu-constructors/Menu'
var Menus = /** @class */ (function () {
    function Menus(editor) {
        this.editor = editor;
        this.menuList = [];
        this.constructorList = menu_list_1.default; // 所有菜单构造函数的列表
    }
    /**
     * 自定义添加菜单
     * @param key 菜单 key ，和 editor.config.menus 对应
     * @param Menu 菜单构造函数
     */
    Menus.prototype.extend = function (key, Menu) {
        if (!Menu || typeof Menu !== 'function')
            return;
        this.constructorList[key] = Menu;
    };
    // 初始化菜单
    Menus.prototype.init = function () {
        var _this = this;
        // 从用户配置的 menus 入手，看需要初始化哪些菜单
        var config = this.editor.config;
        config.menus.forEach(function (menuKey) {
            var MenuConstructor = _this.constructorList[menuKey]; // 暂用 any ，后面再替换
            if (MenuConstructor == null || typeof MenuConstructor !== 'function') {
                // 必须是 class
                return;
            }
            // 创建 menu 实例，并放到 menuList 中
            var m = new MenuConstructor(_this.editor);
            m.key = menuKey;
            _this.menuList.push(m);
        });
        // 渲染 DOM
        this._addToToolbar();
    };
    // 添加到菜单栏
    Menus.prototype._addToToolbar = function () {
        var editor = this.editor;
        var $toolbarElem = editor.$toolbarElem;
        // 遍历添加到 DOM
        this.menuList.forEach(function (menu) {
            var $elem = menu.$elem;
            if ($elem) {
                $toolbarElem.append($elem);
            }
        });
    };
    /**
     * 获取菜单对象
     * @param 菜单名称 小写
     * @return Menus 菜单对象
     */
    Menus.prototype.menuFind = function (key) {
        var menuList = this.menuList;
        for (var i = 0, l = menuList.length; i < l; i++) {
            if (menuList[i].key === key)
                return menuList[i];
        }
        return menuList[0];
    };
    /**
     * @description 修改菜单激活状态
     */
    Menus.prototype.changeActive = function () {
        this.menuList.forEach(function (menu) {
            setTimeout(menu.tryChangeActive.bind(menu), 100); // 暂用 any ，后面再替换
        });
    };
    return Menus;
}());
exports.default = Menus;
